import React, { useEffect, useState } from 'react'
import { ColDef } from '@ag-grid-community/core';

import DataTable from '../../reusables/DataTable';
import { SVGIcon } from '../../wrappers/SVGIcon';

import useGetOrganizations from '../../../hooks/organization/useGetOrganizations';

import { IOrganization } from '../../../types/organization';

import { Icons } from '../../../data/Assets';

interface IOrganizationProps {
    applicantId: number;
}

export interface IOrganizationList {
    [name: string]: boolean;
};

const initialAccordionState = { organization: true }

const Organization = ({ applicantId }: IOrganizationProps) => {

    const [organizations, setOrganizations] = useState<IOrganization[] | null>(null);
    const [accordion, setAccordion] = useState<IOrganizationList>(initialAccordionState); // eslint-disable-line

    const { data: organizationsData, isPending, isError } = useGetOrganizations(applicantId);

    useEffect(() => {
        setOrganizations(organizationsData?.data ? organizationsData.data : null);
    }, [organizationsData]); //eslint-disable-line

    const organizationColumns: ColDef[] = [
        { field: "name", headerName: "Name" },
        { field: "date_linked", headerName: "Date Linked", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "N/A" },
        { field: "date_unlinked", headerName: "Date Unlinked", valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : "N/A" },
        {
            field: "linked", headerName: "Linked", valueFormatter: (params) => params.value ? "Yes" : "No", cellRenderer: function (params: { value: boolean }) {
                return params.value ? <SVGIcon src={Icons.Checkmark} /> : <SVGIcon src={Icons.X} />
            }
        },
    ]


    if (isPending) return <div className="imm_consultant__loading"><div className="imm_consultant__process_loader" />Loading...</div>
    if (isError) return <div className="imm_consultant__loading">Something went wrong. Please try again later.</div>

    return (
        <div className='imm_information__main'>
            <div className={accordion["organization"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => null}>Organizations</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={organizations ?? []} columns={organizationColumns} filter={false} /></div>
                </div>
            </div>
        </div>
    );
}
export default Organization;